import { Action, Reducer } from "common/types/redux";

import { convertToUser } from "seneca-common/features/parents/features/utils";
import {
  receiveUser as receiveUserAction,
  receiveUsers as receiveUsersAction,
  UsersState,
  UserType
} from "seneca-common/features/users/state";

import actionTypes from "../action-types";

export default function usersReducerWrapper(usersReducer: Reducer<UsersState>) {
  return (state: UsersState, action: Action<any>) => {
    switch (action.type) {
      case actionTypes.RECEIVE_STUDENT_PARENTS:
        const parents = action.payload;
        const parentsToUsers: UserType[] = parents.map(convertToUser);
        return usersReducer(state, receiveUsersAction(parentsToUsers));

      case actionTypes.RECEIVE_STUDENT_PARENT:
        const parentToUser: UserType = convertToUser(action.payload);
        return usersReducer(state, receiveUserAction(parentToUser));

      default:
        return usersReducer(state, action);
    }
  };
}
